import { createFileRoute } from "@tanstack/react-router";
import { supabaseAdmin } from "@/integrations/supabase/client.server";

export const Route = createFileRoute("/api/public/notify-registration")({
  server: {
    handlers: {
      POST: async () => {
        try {
          // Fetch newest registration + settings
          const [{ data: regs }, { data: settings }] = await Promise.all([
            supabaseAdmin.from("registrations").select("*").order("created_at", { ascending: false }).limit(1),
            supabaseAdmin.from("site_settings").select("*").eq("id", 1).maybeSingle(),
          ]);
          const reg = regs?.[0];
          const to = settings?.notification_email;
          if (!reg || !to) return Response.json({ ok: true, sent: false });

          const subject = `${settings?.subject_prefix || "[הרשמה חדשה]"} ${reg.parent_name} - ${reg.student_name}`;
          const body = `הרשמה חדשה התקבלה באתר:

הורה: ${reg.parent_name}
טלפון: ${reg.phone}
${reg.email ? `אימייל: ${reg.email}\n` : ""}שם הבן: ${reg.student_name}
${reg.student_age ? `גיל/כיתה: ${reg.student_age}\n` : ""}${reg.message ? `הערות: ${reg.message}\n` : ""}
התקבל ב: ${new Date(reg.created_at).toLocaleString("he-IL")}`;

          console.log("[notify-registration] would send email", { to, subject, body });
          // Email delivery hook — wire to Lovable Email or a provider when configured.
          return Response.json({ ok: true, sent: false, queued: true });
        } catch (e: any) {
          console.error(e);
          return Response.json({ ok: false, error: e.message }, { status: 500 });
        }
      },
    },
  },
});
